const readFileAsync = (file: File) => {
  return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsArrayBuffer(file);
  });
};

/**
 * The method formats a byte value short hand
 *
 * @param bytes source bytes
 * @param decimals  decimals to round off
 */

const formatBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

const saveAsFile = (fileBlob?: Blob, fileName?: string): void => {
  if (fileBlob && fileName) {
    const csvURL = window.URL.createObjectURL(fileBlob);
    const anchorElement = document.createElement("a");
    anchorElement.href = csvURL;
    anchorElement.setAttribute("download", fileName);
    anchorElement.click();
    anchorElement.remove();
  }
};

const fileFromUrl = async (url: string, name: string) => {
  const element = document.createElement("a");
  element.setAttribute("download", name);
  element.href = url;
  element.download = name;
  element.click();
  element.remove();
};

export { readFileAsync, formatBytes, saveAsFile, fileFromUrl };
